/** The visible chip inside a full-width date row, or the element itself. */
export function dateControlRect(el) {
  if (!el) return null;
  const chip = el.querySelector('[class*="date-row-value-inner"]');
  return (chip || el).getBoundingClientRect();
}

export function getEdgeAwarePosition(rect, popupWidth = 280, popupHeight = 320, align = 'end') {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const padding = 8;

  let left = align === 'end' ? rect.right - popupWidth : rect.left;

  if (left + popupWidth > viewportWidth - padding) {
    left = viewportWidth - popupWidth - padding;
  }

  if (left < padding) {
    left = padding;
  }

  const gap = 4;
  const belowTop = rect.bottom + gap;
  const aboveTop = rect.top - popupHeight - gap;
  const fitsBelow = belowTop + popupHeight <= viewportHeight - padding;
  const fitsAbove = aboveTop >= padding;

  let top = belowTop;
  if (!fitsBelow && fitsAbove) {
    top = aboveTop;
  } else if (!fitsBelow) {
    const spaceBelow = viewportHeight - padding - belowTop;
    const spaceAbove = rect.top - gap - padding;
    top = spaceBelow >= spaceAbove ? belowTop : aboveTop;
    if (top < padding) top = padding;
    const maxTop = viewportHeight - padding - popupHeight;
    if (top > maxTop) top = Math.max(padding, maxTop);
  }

  return { top, left };
}
